import { useSelector } from 'hooks/utils';
import { selectCollaboratorsData } from 'store/data/collaborators';

export function useCollaboratorsData() {
	return useSelector(state => selectCollaboratorsData(state.data.collaborators));
}
